import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, ...rest }) => {
	const categoryPath = (paymentCategory) => {
		switch (paymentCategory) {
			case 'Lesson': return 'paymentHistory';
			case 'Workshop': return 'workshopPayments';
			case 'Consultation': return 'individualConsultations';
		}
	}
	
	const columns = [
		{
			header: t('CancellationCreditNote_CancellationDate'),
			accessor: 'cancellationDate',
			sortable: true,
			cell: (cancellationDate) => (ui.formatDateTime(cancellationDate))
		},
		{
			header: t('CancellationCreditNote_CancellationReason'),
			accessor: 'cancellationReason',
			cell: (cancellationReason, row) => t(`CancellationReasonType_${cancellationReason}`) + (cancellationReason == 'Other' && row.otherCancellationReason ? ": " + row.otherCancellationReason : ""),
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Quantity'),
			accessor: 'quantity',
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Amount'),
			accessor: 'amount',
			cell: (amount) => ui.formatAmount(amount),
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Payment'),
			accessor: 'rootPaymentId',
			cell: (rootPaymentId, row) => (<Link to={
				`/${categoryPath(row.paymentCategory)}/${rootPaymentId}`} > {rootPaymentId}</Link>),
			sortable: false
		},
		{
			header: t('CancellationCreditNote_PaymentCategory'),
			accessor: 'paymentCategory',
			cell: (paymentCategory) => <span>{t(`PaymentCategory_${paymentCategory}`)}</span>,
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Center'),
			accessor: 'center.name',
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Parent'),
			accessor: 'parent',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}`} > {row.parent.name}</Link>),
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Child'),
			accessor: 'child',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}/children/${row.child.id}`} > {child.name}</Link>),
			sortable: false
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);